/* Waxit cart extras. Fetches sections/wx-cart-extras via the Section Rendering API after every Dawn cart render and slots the fragments into Dawn's cart drawer and, on /cart, into the cart page. No Dawn files touched. */
(function () {
  var URL_ = '/?section_id=wx-cart-extras';
  var timer = null;
  function q(s, r) { return (r || document).querySelector(s); }
  function onCartPage() { return !!document.getElementById('main-cart-items'); }
  /* The containers the extras go into: the drawer (every page) and the /cart page (only on /cart). */
  function containers() {
    var out = [], d = q('cart-drawer'); if (d) out.push({ el: d, kind: 'drawer' });
    if (onCartPage()) { var p = q('cart-items'); if (p) out.push({ el: p, kind: 'page' }); }
    return out;
  }
  function makeHost(name, kind) { var h = document.createElement('div'); h.setAttribute('data-wx-cx-host', name); if (kind === 'page') h.className = 'wx-cx-page wx-cx-page--' + name; return h; }
  function slot(c, name, html) {
    var box = c.el, host = c.kind === 'page' ? q('.wx-cx-page--' + name) : q('[data-wx-cx-host="' + name + '"]', box);
    if (!host) {
      host = makeHost(name, c.kind);
      if (c.kind === 'drawer') {
        if (name === 'top') { var h = q('.drawer__header', box); h && h.insertAdjacentElement('afterend', host); }
        else if (name === 'mid') { var contents = q('.drawer__contents', box) || q('cart-drawer-items', box); contents && contents.appendChild(host); }
        else { var foot = q('.cart-drawer__footer', box); foot && foot.insertAdjacentElement('afterend', host); }
      } else {
        /* Cart page: top and mid sit OUTSIDE form#cart so their controls never trip Dawn's quantity validation; foot sits under the totals. */
        var form = q('#cart', box);
        if (name === 'top') { form && form.insertAdjacentElement('beforebegin', host); }
        else if (name === 'mid') { form && form.insertAdjacentElement('afterend', host); }
        else { var tot = q('#main-cart-footer .cart__blocks .js-contents') || q('#main-cart-footer .cart__blocks'); tot && tot.insertAdjacentElement('afterend', host); }
      }
      if (!host.parentNode) return null;
    }
    /* Compare against the last server HTML, not the live DOM, so a size picked in Pair it with is not wiped by a refresh that changed nothing. */
    if (host.__wxHtml !== (html || '')) { host.innerHTML = html || ''; host.__wxHtml = html || ''; }
    return host;
  }
  function tick(box) {
    var d = q('[data-wx-cx-dispatch]', box), t = q('[data-wx-cx-dispatch-text]', box);
    if (!d || !t) return;
    try {
      var mel = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }));
      var day = mel.getDay(), cut = new Date(mel); cut.setHours(14, 0, 0, 0);
      var ms = cut - mel;
      if (day >= 1 && day <= 5 && ms > 0) { var h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4); t.innerHTML = 'Order in the next <b>' + (h ? h + 'h ' : '') + m + 'm</b> for dispatch today'; }
      else t.textContent = 'Dispatched next business day';
      d.hidden = false;
    } catch (e) {}
  }
  function tickAll() { containers().forEach(function (c) { tick(c.el); }); }
  /* After a Pair add or kit swap: on /cart reload (Dawn's cart page has no renderContents); elsewhere let the drawer re-render. */
  function render(state) {
    if (onCartPage()) { location.reload(); return; }
    var cd = q('cart-drawer'); if (cd && cd.renderContents && state && state.sections) { cd.renderContents(state); refocus(cd); } else location.reload();
  }
  /* 5 Oct 2026: Dawn's open() skips its focus trap when the drawer is already open, so after a Pair add or kit swap focus fell back to the page behind the drawer (Esc and Tab stopped working). Put it back on the drawer. */
  function refocus(cd) { setTimeout(function () { var inner = q('.drawer__inner', cd); if (!inner || !cd.classList.contains('active')) return; if (!inner.hasAttribute('tabindex')) inner.setAttribute('tabindex', '-1'); try { if (window.trapFocus) window.trapFocus(inner, inner); else inner.focus(); } catch (e) { inner.focus(); } }, 60); }
  /* 5 Oct 2026: quantity +/- or remove pressed just before Swap. Dawn waits 300 ms and then saves; Swap now waits for that to finish and reads the real quantity, instead of the one from the last render (a quick 3 -> 1 then Swap used to leave the kit plus 2 items). */
  var lastQty = 0;
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button, cart-remove-button')) lastQty = Date.now(); }, true);
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('.quantity__input')) lastQty = Date.now(); }, true);
  function settled() {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function chk() { var busyNow = Date.now() - lastQty < 600 || !!document.querySelector('.cart__items--disabled'); if (busyNow && Date.now() - t0 < 6000) setTimeout(chk, 100); else res(); })();
    });
  }
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); }); }
  function fail(btn, label, res) {
    btn.disabled = false; btn.textContent = label;
    var msg = (res && res.body && (res.body.description || res.body.message)) || 'Sorry, that could not be added.';
    var card = btn.closest('.wx-cx__kit, .wx-cx__pair'), n = card && q('.wx-cx__err', card);
    if (card && !n) { n = document.createElement('small'); n.className = 'wx-cx__err'; n.setAttribute('role', 'alert'); card.appendChild(n); }
    if (n) n.textContent = msg;
  }
  function bindSwap(box) {
    var k = q('[data-wx-cx-kit]', box), btn = q('[data-wx-cx-swap]', box);
    if (!k || !btn || btn.dataset.bound) return; btn.dataset.bound = '1';
    var label = btn.textContent;
    btn.addEventListener('click', function () {
      btn.disabled = true; btn.textContent = 'Swapping…';
      /* Add the kit FIRST. Only if that worked, take ONE unit off the source line (extra units stay). If the kit can't be added, nothing is removed.
         5 Oct 2026: if the unit can't be taken off (app-locked line, quantity rules), the kit is taken back out so nobody pays for both. */
      settled().then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (i) { return i.key === k.dataset.line; })[0];
          return post('/cart/add.js', { items: [{ id: parseInt(k.dataset.variant, 10), quantity: 1, properties: { _is_kit_swap: 'true' } }] })
            .then(function (res) {
              if (!res.ok) { fail(btn, label, res); return; }
              if (!line) return post('/cart/update.js', { updates: {}, sections: 'cart-drawer,cart-icon-bubble' }).then(function (r3) { render(r3.body); });
              return post('/cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - 1), sections: 'cart-drawer,cart-icon-bubble' }).then(function (r2) {
                if (r2.ok) { render(r2.body); return; }
                var added = res.body && res.body.items && res.body.items[0];
                return (added ? post('/cart/change.js', { id: added.key, quantity: Math.max(0, added.quantity - 1) }) : Promise.resolve()).then(function () { location.reload(); });
              });
            });
        })
        .catch(function () { location.reload(); });
    });
  }
  /* Pair it with: size pills / dropdown (rendered by wx-cart-extras) point the card's Add button at the chosen variant. */
  function bindSizes(box) {
    box.querySelectorAll('[data-wx-cx-sizes]').forEach(function (sz) {
      if (sz.dataset.bound) return; sz.dataset.bound = '1';
      var card = sz.closest('.wx-cx__pair'), btn = card && q('[data-wx-cx-add]', card); if (!btn) return;
      var set = function (id, price) { if (!id || btn.disabled) return; btn.dataset.wxCxAdd = id; btn.textContent = 'Add · ' + price; var al = btn.getAttribute('aria-label'); if (al) btn.setAttribute('aria-label', al.replace(/ to cart, .*$/, ' to cart, ' + price)); };
      var sel = q('select', sz);
      /* stopPropagation: in the drawer this select sits inside Dawn's <cart-drawer-items> form. Letting its change event bubble made Dawn treat it as a quantity box, mark it invalid and block Check out. */
      if (sel) sel.addEventListener('change', function (e) { e.stopPropagation(); var o = sel.selectedOptions[0]; if (o) set(o.value, o.getAttribute('data-price')); });
      sz.addEventListener('click', function (e) {
        var p = e.target.closest('[data-wx-cx-size]'); if (!p || p.disabled || btn.disabled) return;
        sz.querySelectorAll('[data-wx-cx-size]').forEach(function (x) { var on = x === p; x.classList.toggle('is-selected', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        set(p.getAttribute('data-wx-cx-size'), p.getAttribute('data-price'));
      });
    });
  }
  function bindPair(box) {
    bindSizes(box);
    box.querySelectorAll('[data-wx-cx-add]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        post('/cart/add.js', { items: [{ id: parseInt(btn.dataset.wxCxAdd, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
          .then(function (res) { if (!res.ok) { fail(btn, label, res); return; } render(res.body); })
          .catch(function () { location.reload(); });
      });
    });
  }
  function setCount(drawer, root) {
    var h = q('.drawer__heading', drawer); if (!h) return;
    var n = root && root.getAttribute('data-wx-cx-count');
    var c = q('[data-wx-cx-heading-count]', h);
    if (!c) { c = document.createElement('span'); c.setAttribute('data-wx-cx-heading-count', ''); c.className = 'wx-cx__count'; h.appendChild(c); }
    var txt = n && n !== '0' ? (n === '1' ? '1 item' : n + ' items') : '';
    if (c.textContent !== txt) c.textContent = txt;
  }
  function setClass(el, name, on) { if (!el) return; if (el.classList.contains(name) !== !!on) el.classList.toggle(name, !!on); }
  function syncEmpty(drawer) {
    // Dawn sets/clears .is-empty in several places (renderContents, CartItems.updateQuantity). Derive the truth from the DOM every time so wx-has-items and is-empty never disagree.
    var has = !!q('.cart-item', drawer);
    setClass(drawer, 'wx-has-items', has);
    setClass(drawer, 'is-empty', !has);
    setClass(q('cart-drawer-items', drawer), 'is-empty', !has);
  }
  /* One fetch at a time. A refresh asked for while one is running is not dropped: it runs again as soon as the first finishes, so the extras always end on the latest cart. */
  var busy = false, again = false;
  function refresh() {
    var list = containers(); if (!list.length) return;
    if (busy) { again = true; return; }
    var drawer = q('cart-drawer'); if (drawer) syncEmpty(drawer);
    busy = true; again = false;
    fetch(URL_, { cache: 'no-store' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var top = q('[data-wx-cx-slot="top"]', doc), mid = q('[data-wx-cx-slot="mid"]', doc), foot = q('[data-wx-cx-slot="foot"]', doc);
      containers().forEach(function (c) {
        slot(c, 'top', top && top.innerHTML); slot(c, 'mid', mid && mid.innerHTML); slot(c, 'foot', foot && foot.innerHTML);
        var scope = c.kind === 'page' ? document.body : c.el;
        if (c.kind === 'drawer') setCount(c.el, q('[data-wx-cx]', doc));
        tick(c.kind === 'page' ? q('.wx-cx-page--mid') || c.el : c.el);
        if (c.kind === 'page') { document.querySelectorAll('.wx-cx-page').forEach(function (h) { bindSwap(h); bindPair(h); }); }
        else { bindSwap(scope); bindPair(scope); }
      });
    }).catch(function () {}).then(function () { busy = false; if (again) schedule(30); });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(refresh, ms || 60); }
  function isOurs(n) { return n && n.nodeType === 1 && (n.hasAttribute('data-wx-cx-host') || n.hasAttribute('data-wx-cx-heading-count') || (n.closest && n.closest('[data-wx-cx-host]'))); }
  function relevantMutations(muts, watchClass) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.target.closest && m.target.closest('[data-wx-cx-host]')) continue;
      if (m.type === 'attributes') {
        if (!watchClass) continue;
        /* Only is-empty matters. Open/close animation classes (active, animate) are not cart changes. */
        var was = / is-empty /.test(' ' + (m.oldValue || '') + ' '), now = m.target.classList.contains('is-empty');
        if (was !== now) return true;
        continue;
      }
      var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
      for (var j = 0; j < nodes.length; j++) { if (nodes[j].nodeType === 1 && !isOurs(nodes[j])) return true; }
    }
    return false;
  }
  var observed = false, observedPage = false;
  function observe() {
    if (!('MutationObserver' in window)) return;
    var drawer = q('cart-drawer');
    if (drawer && !observed) {
      observed = true;
      // Whenever Dawn swaps the drawer's markup (add, quantity, remove) or flips is-empty, re-sync and re-inject. Our own host/heading writes are ignored.
      new MutationObserver(function (muts) {
        if (!relevantMutations(muts, true)) return;
        syncEmpty(drawer);
        schedule(q('.cart-item', drawer) && !q('[data-wx-cx-host="mid"]', drawer) ? 30 : 150);
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class'] });
    }
    if (onCartPage() && !observedPage) {
      observedPage = true;
      /* Cart page: Dawn replaces .js-contents in main-cart-items and main-cart-footer after every quantity change or removal. */
      var pageObs = new MutationObserver(function (muts) { if (relevantMutations(muts, false)) schedule(150); });
      var items = document.getElementById('main-cart-items'), footer = document.getElementById('main-cart-footer');
      if (items) pageObs.observe(items, { childList: true, subtree: true });
      if (footer) pageObs.observe(footer, { childList: true, subtree: true });
    }
  }
  function hook() {
    var CD = window.customElements && customElements.get('cart-drawer');
    if (CD && CD.prototype && !CD.prototype.__wx) {
      CD.prototype.__wx = true;
      var orig = CD.prototype.renderContents;
      CD.prototype.renderContents = function () { var r; try { r = orig.apply(this, arguments); } catch (e) { console.warn('wx-cart: renderContents', e); } var self = this; setTimeout(function () { syncEmpty(self); }, 0); schedule(120); return r; };
      var origOpen = CD.prototype.open;
      CD.prototype.open = function () {
        var self = this, args = arguments;
        // Dawn's open() focuses .drawer__inner after its transition. Make sure it exists and is focusable before Dawn looks for it.
        var inner = q('.drawer__inner', self); if (inner && !inner.hasAttribute('tabindex')) inner.setAttribute('tabindex', '-1');
        syncEmpty(self);
        // Dawn's open() trapFocus targets .drawer__inner-empty when is-empty was set at open time; that node is gone once items render and getFocusableElements(null) throws. Wrap the global for the duration of the open.
        if (window.trapFocus && !window.trapFocus.__wx) {
          var tf = window.trapFocus; var wrapped = function (container, focusEl) { if (!container) container = q('.drawer__inner', self) || self; try { return tf.call(this, container, focusEl); } catch (e) { console.warn('wx-cart: trapFocus', e); } };
          wrapped.__wx = true; window.trapFocus = wrapped;
        }
        var r;
        try { r = origOpen.apply(self, args); } catch (e) { self.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
        if (!q('[data-wx-cx-host]', self)) schedule(120);
        return r;
      };
    }
    var CI = customElements.get('cart-drawer-items');
    if (CI && CI.prototype && !CI.prototype.__wx) {
      CI.prototype.__wx = true;
      var origU = CI.prototype.updateQuantity;
      if (origU) CI.prototype.updateQuantity = function () { var r = origU.apply(this, arguments); schedule(400); return r; };
    }
    // pubsub.js declares PUB_SUB_EVENTS with const, so it is NOT on window — read the bare global.
    try { if (!hook.__sub && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { hook.__sub = true; subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(60); }); } } catch (e) {}
    observe();
  }
  /* Cart page layout for the extras. Kept here so /cart needs no extra stylesheet; the fragment styles themselves live in wx-cart.css. */
  function pageStyles() {
    if (!onCartPage() || document.getElementById('wx-cx-page-css')) return;
    var s = document.createElement('style'); s.id = 'wx-cx-page-css';
    s.textContent = '.wx-cx-page--top:not(:empty){margin:0 0 2rem;padding:1.2rem 1.6rem;border:1px solid var(--wx-line,#e5e5e5);background:#fff;max-width:64rem}' +
      '.wx-cx-page--mid:not(:empty){margin:2.4rem 0 0;max-width:64rem}' +
      '.wx-cx-page--mid .wx-cx__notice:first-child,.wx-cx-page--mid .wx-cx__dispatch:first-child{margin-top:0}' +
      '.wx-cx-page--foot:not(:empty){margin:.8rem 0 0;text-align:right}' +
      'cart-items.is-empty .wx-cx-page{display:none}' +
      '.wx-cx__err{grid-column:1/-1;display:block;color:#b3261e;font-size:1.2rem;line-height:1.35}';
    document.head.appendChild(s);
  }
  /* 5 Oct 2026: the Gorgias chat button (and Smile's launcher on phones) sat on top of the drawer's Check out button. Hide them while the drawer is open, same as the newsletter popup does. */
  function chatStyles() {
    if (document.getElementById('wx-cx-chat-css')) return;
    var s = document.createElement('style'); s.id = 'wx-cx-chat-css';
    s.textContent = 'body:has(cart-drawer.active) #gorgias-chat-container,body:has(cart-drawer.active) #smile-ui-container,body:has(cart-drawer.active) #swym-anchor{display:none!important}';
    document.head.appendChild(s);
  }
  /* 5 Oct 2026: no extras fetch on page load for an empty cart (every visitor's page view used to request it). The observer and hooks load them on the first add. */
  function start() { pageStyles(); chatStyles(); hook(); var cd = q('cart-drawer'); if (onCartPage() || (cd && q('.cart-item', cd))) schedule(); setInterval(tickAll, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); }); else setTimeout(start, 0);
  customElements.whenDefined && customElements.whenDefined('cart-drawer').then(hook);
})();
